import { call, put, takeEvery, all } from "redux-saga/effects";

import * as API from "modules/user/user-api-saga";
import UserActions from "modules/user/user-actions";
import {
  withErrorHandlingNoRethrow,
  composeSaga
} from "modules/root/saga-helpers";

export function* onUpdateUser({ values }) {
  const {
    age,
    weight,
    height,
    sex,
    properties,
    medical_properties,
    first_name,
    last_name,
    language
  } = values;
  const resp = yield call(API.updateUser, {
    age,
    weight,
    height,
    sex,
    properties,
    medical_properties,
    first_name,
    last_name,
    language
  });
  const user = resp.data.data;
  yield put(UserActions.Creators.userFetched(user));
}

export default function* userSaga() {
  yield all([
    takeEvery(
      UserActions.Types.GENERAL_INFO_UPDATED,
      composeSaga(withErrorHandlingNoRethrow, onUpdateUser)
    )
  ]);
}



// WEBPACK FOOTER //
// ./src/modules/user/user-saga.js